import React from 'react'
import { useParams } from 'react-router-dom'
import CmsPageScreen from '../Component/CmsPageScreen'

function PageView() {
  const { pageId, pageSlug } = useParams()
  const key = pageId || pageSlug || ''
  const isNumeric = /^\d+$/.test(String(key))

  return (
    <CmsPageScreen
      pageId={isNumeric ? key : undefined}
      pageUrl={isNumeric ? undefined : key}
    />
  )
}

export default PageView
